/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/rx-refills-list';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        refillNumber: 40,
        orderNumber: 60,
        drugName: 120,
        daysSupply: 60,
        quantity: 60,
        youPaid: 50,
        status: 100,
        trackingNumber: 120,
        shippingDate: 60,

        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 100, // group actions column
    },
    filterFlyoutWidths: {
        rxNumber: 180,
        status: 300
    },
    valueColors: {},
    actionIcons: {
        toDos: 'checkedContent',
        renewRx: 'checkedContent',
        refillRx: 'checkedContent',
        checkout: 'cart'
    },
};
